import './style.scss';
import React, { useEffect, useState } from 'react';
import AloModal from 'src/scripts/templates/_shared/ui-components/YogaUI/alo-ui/AloModal';
import { heapTrack } from '../../../../utils/helpers';
import { isEmpty, mapValues } from 'lodash-es';

const LoyaltySuccessModal = ({
  isOpen = true,
  modalSettings,
}: {
  isOpen?: boolean;
  modalSettings: SuccessModalSettings;
}) => {
  const {
    discountCode,
    titleAfterLogo = 'Member',
    titleBeforeLogo = 'Congrats',
    ctaText,
    ctaUrl,
    closeCtaEnable,
    closeCtaText,
    closeCtaTextColor,
    closeCtaUrl,
    benefits,
    benefitsTitle = 'These benefits are now yours:',
    heroImage,
    discountTitle,
    discountDetails,
  } = mapValues(modalSettings, (val) => (typeof val === 'string' ? val.trim() : val)) as SuccessModalSettings;

  const [shouldShowClipboardFeedback, setShouldShowClipboardFeedback] = useState(false);
  const customerData = window.getCustomerInfo && window.getCustomerInfo();
  const loyaltyTier = customerData?.loyalty_tier ? customerData?.loyalty_tier : 'tier1';
  const iconTiers = {
    tier1: 'https://cdn.shopify.com/s/files/1/2185/2813/files/VIP_Silver_1.png?v=1727985360',
    tier2: 'https://cdn.shopify.com/s/files/1/2185/2813/files/ALIST_tier2_1.png?v=1727985360',
    tier3: 'https://cdn.shopify.com/s/files/1/2185/2813/files/ALLACCESS_tier3_1.png?v=1727985636',
  };
  const loyaltyIcon = iconTiers[loyaltyTier as keyof typeof iconTiers];

  useEffect(() => {
    if (isOpen) heapTrack('Web - Success Modal Is Shown', {}); // No need to abstract this event cause it's a unique to this useEffect block.
    document.body.classList.add('success-modal-open');
    return () => {
      document.body.classList.remove('success-modal-open');
    };
  }, [isOpen]);

  const copyContent = () => {
    navigator.clipboard.writeText(discountCode || '').then(
      () => {},
      () => {
        console.error('Failed to copy');
      }
    );
  };

  const tierStyles: TierStyles = {
    tier1: { textClass: 'tier1-text', imageWidth: 140 },
    tier2: { textClass: 'tier2-text', imageWidth: 150 },
    tier3: { textClass: 'tier3-text', imageWidth: 300 },
  };

  return (
    <AloModal
      open={isOpen}
      showCloseButton={true}
      closeElement="button.closeLoyaltySuccessModal"
      wrapperClass="loyalty-success-modal"
    >
      <img
        src={
          heroImage && !heroImage.includes('no-image')
            ? heroImage
            : 'https://cdn.shopify.com/s/files/1/2185/2813/files/c1539b885630b3ced98d4de1b96cb399.png?v=1727291255'
        }
        alt=""
        className="img-fluid success-modal-hero"
      />
      <div className={`loyalty-success ${loyaltyTier}`}>
        <div className={`hero-message ${loyaltyTier}`}>
          <div className={loyaltyTier === 'tier3' ? 'column-layout' : 'row-layout'}>
            <span className={tierStyles[loyaltyTier]?.textClass}>{titleBeforeLogo}</span>
            <img alt={loyaltyTier} src={loyaltyIcon} width={tierStyles[loyaltyTier]?.imageWidth} />
            <span className={loyaltyTier === 'tier3' ? 'tier3-member' : tierStyles[loyaltyTier]?.textClass}>
              {titleAfterLogo}
            </span>
          </div>
        </div>

        <div className="benefits-content">
          {discountCode && discountCode.length > 2 ? (
            <div className="discount-wrapper">
              <p className="discount-title">{discountTitle}</p>
              <div
                className="access-code"
                style={shouldShowClipboardFeedback ? { cursor: 'not-allowed' } : { cursor: 'copy' }}
                onClick={() => {
                  copyContent();
                  setShouldShowClipboardFeedback(true);
                  setTimeout(() => {
                    setShouldShowClipboardFeedback(false);
                  }, 2000);
                }}
              >
                {shouldShowClipboardFeedback ? 'Copied!' : discountCode}
              </div>
              <p className="discount-details">{discountDetails}</p>
            </div>
          ) : null}

          <div className="body semibold uppercase mb-md">{benefitsTitle}</div>
          <ul>
            {benefits ? (
              <>
                {benefits.map((benefit) => {
                  return isEmpty(benefit.tiers) || benefit.tiers?.includes(loyaltyTier) ? (
                    <li>
                      <img src={benefit.image} alt={benefit.text} />
                      {benefit.text}
                    </li>
                  ) : null;
                })}
              </>
            ) : (
              // [REVISIT] Do we need this Back up in case settings object is undefined??? Overkill???
              <>
                <li className="welcome-gift">
                  <img src="https://cdn.shopify.com/s/files/1/2185/2813/files/welcome_gift.png?v=1727180845" alt="" />
                  Welcome Gift
                </li>
                <li className="birthday-gift">
                  <img src="https://cdn.shopify.com/s/files/1/2185/2813/files/birthday-gift.png?v=1727331381" alt="" />
                  Birthday Gift
                </li>
                <li className="members-only-sales">
                  <img
                    src="https://cdn.shopify.com/s/files/1/2185/2813/files/member-only-sale.png?v=1727331355"
                    alt=""
                  />
                  Members-Only Sales
                </li>
              </>
            )}
          </ul>
          {ctaText && ctaUrl ? (
            <a className="view-access-pass" href={ctaUrl}>
              {ctaText}
            </a>
          ) : null}
          {closeCtaEnable && closeCtaText ? (
            closeCtaUrl ? (
              <a href={closeCtaUrl} style={{ color: closeCtaTextColor }}>
                {closeCtaText}
              </a>
            ) : (
              <button className="closeLoyaltySuccessModal" style={{ color: closeCtaTextColor }}>
                {closeCtaText}
              </button>
            )
          ) : null}
        </div>
      </div>
    </AloModal>
  );
};
export { LoyaltySuccessModal };

interface TierStyle {
  textClass: string;
  imageWidth: number;
}

interface TierStyles {
  [key: string]: TierStyle;
}
